import {Component, OnInit, OnDestroy, HostListener} from '@angular/core';
import {
  FormBuilderService,
  ApplicationService,
  NotificationService,
  WorkbookService,
  CommunicationService,
  SalesService,
  SubmissionService,
  RateService,
  PricingOutput,
  PricingInput, TypesService
} from '../../services/index';
import {WizardFormComponent, WizardSteps} from './wizard-form.component';
import {BaseSubmissionModel} from '../../models/submission/base-submission-model';
import { FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router, ActivatedRoute} from '@angular/router';
import { QuoteResultsComponent } from '../widgets/quote-results/quote-results.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { RateComponent } from '../widgets/rate/rate.component';
import { QuoteDetailsComponent } from '../widgets/quote-details/quote-details.component';
import { CustomerDetailsComponent } from '../widgets/customer-details/customer-details.component';
import { OriginatorBrokerComponent } from '../widgets/originator-broker/originator-broker.component';
import { NgFor, NgClass, NgIf } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import {DataHandlerService} from '../../services/data-handler.service';

@Component({
    selector: 'app-online-quote',
    templateUrl: './online-quote.component.html',
    styles: [],
    standalone: true,
    imports: [MatSidenavModule, MatProgressBarModule, MatListModule, NgFor, NgClass, FormsModule, NgIf, OriginatorBrokerComponent, ReactiveFormsModule, CustomerDetailsComponent, QuoteDetailsComponent, RateComponent, MatButtonModule, MatButtonModule, MatProgressSpinnerModule, MatProgressSpinnerModule, MatFormFieldModule, MatFormFieldModule, QuoteResultsComponent]
})
export class OnlineQuoteComponent extends WizardFormComponent implements OnInit, OnDestroy {
  public wizardName = 'Online Car Loan Quote';
  public baseModel: BaseSubmissionModel;  // New model for quotes?
  public storageIdentifier = 'wiz-online-quote'; // the key for session storage
  public loanPurposeType = 'motor-vehicle-loan';
  public workbookSlug = 'abs-quote';
  public isPersonalLoan = false;
  public isLoading = false;
  public isCompleted = false;
  public isCalculated = false;
  public quoteData: any = {};
  public leadData: any = null;
  public hasSettlement = false; // use this to add the settlement amount field in SSL
  public salesRelatesTo = 'car-loan';
  public salesShop = 'abs-shop';
  public rateData: PricingOutput;
  public rateParams: PricingInput;

  constructor(public formBuilderService: FormBuilderService,
              public dataHandlerService: DataHandlerService,
              public submissionService: SubmissionService,
              public applicationService: ApplicationService,
              public notificationService: NotificationService,
              public sanitizer: DomSanitizer,
              public oauthService: OAuthService,
              public router: Router,
              public activatedRoute: ActivatedRoute,
              public workbookService: WorkbookService,
              public typesService: TypesService,
              public communicationService: CommunicationService,
              public rateService: RateService,
              public salesService: SalesService) {

    super(formBuilderService, dataHandlerService, submissionService, applicationService, notificationService, sanitizer, oauthService,
      router, activatedRoute, workbookService, typesService, communicationService, salesService);
    console.log('[online-quote]', 'Init Online Quote');
  }

  public steps: WizardSteps[] = [{
    icon: 'arrow_forward',
    name: 'Quote details',
    widgets: [
      {name: 'app-originator-broker', class: 'col-sm-12'},
      {name: 'app-customer-details', class: 'col-sm-12'},
      {name: 'app-quote-details', class: 'col-sm-12'},
      {name: 'app-quote-results', class: 'col-sm-12'},
      {name: 'app-rate', class: 'col-sm-12'}, // this needs to be at the bottom so that it can override the selected rates
    ],
    classNameStatus: 'default'
  }];

  @HostListener('window:beforeunload', ['$event'])
  clearSession($event) {
    this.clearForm();
  }

  ngOnInit() {
    console.log('Initialize broker Quotes');
    super.ngOnInit();
    this.initQuote();
    this.initRates();
  }

  ngOnDestroy() {
    this.clearForm();
  }

  public clearForm() {
    if (this.isCompleted || this.isCalculated) {
      console.log('[Destroy]', this.isCalculated, this.isCompleted);
      sessionStorage.removeItem(this.storageIdentifier);
      sessionStorage.removeItem('quoteId');
      // this.isCompleted = false;
      // this.isCalculated = false;
    }
  }

  public initQuote() {
    const quoteId = sessionStorage.getItem('quoteId') || null;
    console.log('[quoteId] Loading quote:', quoteId);
    if (quoteId) {
      sessionStorage.removeItem('quoteId');
      this.salesService.retrieveQuote(quoteId)
        .subscribe((res) => {
          console.log('[quote]', res);
          this.isCompleted = true;
          this.isCalculated = true;
          this.quoteData = res;
        });
    }
  }

  public initRates() {
    this.rateService.rateData.subscribe((val) => {
      console.debug('initRates.rateData');
      this.rateData = val;
      this.isCalculated = false; // if any of the parameters change, hide the window
    });
    this.rateService.rateParameters.subscribe((val) => {
      console.debug('initRates.rateParameters');
      this.rateParams = val;
    });
  }


  public submitApplication() {
    const data = this.baseform.getRawValue();
    console.log('Form submission ', data);
    console.log('Form Valid?', this.baseform);

    if (this.baseform.valid && this.rateData) {
      this.quoteData = {
        data: data['step-0'],
        lead: (this.quoteData && this.quoteData.lead) ? this.quoteData.lead : null
      };
      this.quoteData['data']['app-quote-results']['monthlyRepayments'] = this.rateData.AdjustedTotalMonthlyRepayments;
      this.quoteData['data']['app-quote-results']['totalRepayments'] = this.quoteData['data']['app-quote-details'].loanTerm.rate.term.value * 12;
      this.quoteData['data']['app-quote-results']['netMonthlyRepayments'] = this.rateData.TotalFinancedAmount;
      // this.quoteData['data']['app-quote-results']['gst'] = // TODO -- might no longer be needed
      this.quoteData['data']['app-quote-results']['totalInterest'] = 'TBD'; // to be calculated

      // submission / create lead
      this.updateSalesDefaults(this.quoteData['data']['app-quote-details']['purpose']);
      let body = this.formBeforeSubmit(data);
      body = this.dataOverwrites(body);
      console.log(JSON.stringify(body));
      this.isLoading = true;
      this.applicationService.submitLead(body)
        .subscribe((sl) => {
          console.log('[LEAD]', sl);
          // add the lead to quote data
          this.quoteData['lead'] = sl.lead;
          // set the expiration
          const expirationDate = new Date();
          expirationDate.setDate(expirationDate.getDate() + 30);
          this.quoteData['expiration'] = expirationDate;
          this.quoteData['data']['app-quote-results']['expiration'] = expirationDate;
          this.quoteData['brokerId'] = this.quoteData['data']['app-originator-broker']['broker'].id;
          console.log('[quoteData]', this.quoteData);

          // save quote
          this.salesService.createQuote(this.quoteData)
            .subscribe((q) => {
              console.log('[SAVED]', q);
              // sessionStorage.setItem('quoteId', q);
              this.isCalculated = true;
              this.isLoading = false;
            }, (err) => {
              console.error('Error during quote creation', err);
              this.isLoading = false;
            });
        }, (err) => {
          console.error('Error during submission', err);
          this.isLoading = false;
        });
    } else {
      console.log('[wizard-form]', '[submitApplication]', '[INVALID]', this.baseform);
      this.notificationService.snackBar('Please fill up all fields with valid values in order to continue.', 'OK', 'warn-snackbar');
      this.markFormGroupTouched(this.baseform);
      this.formBuilderService.showValidationErrors.next(true);
      this.isLoading = false;
      this.isCalculated = false;
    }
  }

  // public mapToWorkbook(data) {
  //   // console.log('[mapToWorkbook]', data);
  //   let totalFees = 0;
  //   data['app-quote-details']['insurances'].forEach((i) => {
  //     totalFees += i.insuranceAmount;
  //   });
  //   const loanTerms = data['app-quote-details']['loanTerm']['rate']['term']['value'] * 12;
  //   const rate = (Number(data['app-quote-details']['loanTerm']['rate']['rtb'] * 100)) + ((Number(data['app-quote-details']['loanTerm']['rate']['loading']) || 0) * 100);
  //   return {
  //     'Residual %': (Number(data['app-quote-details']['balloonPercentage']) / 100),
  //     'Residual $': (Number(data['app-quote-details']['balloonAmount']) || 0),
  //     'Loan Term (Months)': loanTerms,
  //     'Interest Rate': rate / 100,
  //     // 'Total Interest':
  //     'Customer Name': data['app-customer-details']['name'],
  //     'GST': 0,
  //     'Purchase Price': data['app-quote-details']['purchaseRefinanceAmount'] || 0,
  //     'Less deposit': data['app-quote-details']['depositTradeAmount'] || 0,
  //     'Application Fees': data['app-quote-details']['applicationFee'] || 0,
  //     'Origination Fees': data['app-quote-details']['originationFee'] || 0,
  //     'Brokerage': data['app-quote-details']['brokerageFee'] || 0,
  //     'Add fees': totalFees,
  //   };
  // }

  public updateSalesDefaults(purpose) {
    // console.log('[appendSalesDefaults]', purpose);
    switch (purpose) {
      case 'purchase-new-business':
      case 'purchase-used-business':
        this.salesRelatesTo = 'business-car-loan';
        break;

      case 'purchase-new-personal':
      case 'purchase-used-personal':
      case 'refinance-personal':
        this.salesRelatesTo = 'car-loan';
        break;

      default:
        this.salesRelatesTo = 'car-loan';
    }
  }

  public dataOverwrites(body) {
    console.log('[dataOverwrites]', body);
    // overwrite lead creation source
    body.lead.creationSource = 'broker-quote';
    body.lead.shop = this.salesShop;
    body.lead.channel = 'broker-website';
    let partyExternalRef = null;

    if (this.quoteData['lead']) {
      // body.lead.externalRef = (this.quoteData['lead']).externalId;
      body.lead.id = (this.quoteData['lead']).id;
      // body.purposes[0].externalRef = (this.quoteData['lead'].purposes.length > 0) ? (this.quoteData['lead']).purposes[0].externalId : null;
      partyExternalRef = (this.quoteData['lead']).members.find(m => m.role === 'applicant' || m.type === 'customer').externalId;
    }
    // add personList
    let firstName = '';
    let lastName = '';
    let middleName = '';
    const custArr = this.quoteData['data']['app-customer-details']['name'].split(' ');
    custArr.forEach((n, i) => {
      if (i === 0) {
        firstName = n;
      } else if (i === custArr.length - 1) {
        lastName = n;
        middleName = middleName.trim();
      } else {
        middleName += n + ' ';
      }
    });
    const id = String(body.parties.length + 1);
    body.parties.push({
      id,
      type: 'individual',
      firstName,
      lastName,
      otherNames: middleName ? [middleName] : [],
      contact: {
        mobile: this.quoteData['data']['app-customer-details']['phone'],
        email: this.quoteData['data']['app-customer-details']['email'],
      },
      // externalRef: partyExternalRef
    });
    // update purposes
    body.purposes[0].members.push({
      id,
      guarantor: false,
      role: 'applicant'
    });
    return body;
  }
}
